import React from 'react';
import Map, {Marker, Popup} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link} from "react-router-dom";
import FilterEventToggle from "./FilterEventToggle"
import {useFilter} from "../Contexts/FilterContext"
import mapboxgl from "mapbox-gl"
// import Map from "../Contexts/MapContext"
import {useData} from "../Contexts/DataContext"

// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

function MapComponent() {
  const collector = useData();
  const filterData = useFilter();
  const [popupInfo, setPopupInfo] = React.useState(null);

  function getMarkers() {
      return filterData.filter != undefined ? filterData.filter.map((event) => {
        return <Marker longitude={event.longitude.toString()} latitude={event.latitude.toString()} anchor="bottom" onClick={e => {
          setPopupInfo(event);
        }}>
          <LocationOnIcon/>
        </Marker> }):
        collector.data.map((event) => {
        return <Marker longitude={event.longitude.toString()} latitude={event.latitude.toString()} anchor="bottom" onClick={e => {
          setPopupInfo(event);
        }}>
          <LocationOnIcon/>
        </Marker> })
  }

  function getPopupEvents(event) {
    const filteredEvents = JSON.parse(JSON.stringify(filterData.filter != undefined ? filterData.filter: collector.data)).filter((e) => e.location === event.location)
    return filteredEvents.map((e) => {
      return (
      <div>
        <Link to={`/DisplayEvent/${e.eventID}`} className="text-[12px] hover:underline mb-[3px]"><span className="font-bold">{e.eventName}</span> {e.date}, {e.time}, <span className="italic">{e.floorNum}</span></Link>
      </div> 
      )}
      )

  }

  return (
      //React-Mapbox Implementation
      //See https://visgl.github.io/react-map-gl/
      <>
      <FilterEventToggle data={collector.data}/>
        <Map
          initialViewState={{
            longitude: -84.3964,
            latitude: 33.7749,
            zoom: 14
          }}
          style={{width: '100%', height: 500}}
          mapStyle="mapbox://styles/mapbox/streets-v9"
          mapboxAccessToken= {process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
        >
        { collector.data != null && getMarkers() }
        {popupInfo && (
            <Popup
              anchor="top"
              longitude={popupInfo.longitude.toString()}
              latitude={popupInfo.latitude.toString()}
              onClose={() => setPopupInfo(null)}
            >
              <div>
                <p className="text-[15px] mb-[5px] font-bold">{popupInfo.location}</p>
                <hr className="mb-[5px]" />
                {getPopupEvents(popupInfo)}
              </div>
            </Popup>
          )}
        </Map>
      </>
    )
}

export default MapComponent;